import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Footer from './footer'

import '../styles/style.scss';
import ogImage from '../images/lip-sync-battle-social.png'

const Layout = ({ children }) => (
  <div className="wrapper">
    <Helmet
      title="Lip Sync Battle | Denver"
      meta={[
        { name: 'description', content: 'Battle for a Cause, February 8th @ Marquis Theater' },
        { property: 'og:url', content: 'https://www.lipsyncdenver.com' },
        { property: 'og:title', content: 'Denver Lip Sync Battle for Charity'},
        { property: 'og:description', content: 'Battle for a Cause, February 8th @ Marquis Theater. Silent Disco afterparty!'},
        { property: 'og:type', content: 'website'},
        { property: 'og:image', content: `https://www.lipsyncdenver.com${ogImage}`},
        { property: 'og:image:width', content: '1200'},
        { property: 'og:image:width', content: '630'},
        { property: 'keywords', content: 'lip sync battle, denver, deny boredom, downbeat disco, silent disco' },
      ]}
    />
    {children()}
    <Footer />
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js